import { SoftwareType } from './software-type';
import { SoftwarePlatform } from './software-platform';
import { SoftwareArtifact } from './software-artifact';
import { BaseModel } from '../basemodel';

export enum SoftwareStatus {
  MAINTAINED = 'MAINTAINED',
  UNMAINTAINED = 'UNMAINTAINED',
  DEPRECATED = 'DEPRECATED',
}

export enum SoftwareVisibility {
  INTERNAL = 'INTERNAL',
  HIDDEN = 'HIDDEN',
  PREVIEW = 'PREVIEW',
  RELEASED = 'RELEASED',
}

export class Software extends BaseModel {
  name = '';

  description?: string;

  iconUrl?: string;

  status: SoftwareStatus = SoftwareStatus.MAINTAINED;

  visibility: SoftwareVisibility = SoftwareVisibility.INTERNAL;

  type?: SoftwareType;

  platform?: SoftwarePlatform;

  artifacts?: SoftwareArtifact[] = [];
}
